import { render, staticRenderFns } from "./billStatistics.vue?vue&type=template&id=1a183878&scoped=true&"
import script from "./billStatistics.vue?vue&type=script&lang=js&"
export * from "./billStatistics.vue?vue&type=script&lang=js&"
import style0 from "./billStatistics.vue?vue&type=style&index=0&id=1a183878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a183878",
  null
  
)

export default component.exports